export const COMPANIES_FETCHED = 'COMPANIES_FETCHED';
